import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './GreetingBadge.module.scss';
const GreetingBadge = ({ name, subtitle }) => {
    return (_jsxs("div", Object.assign({ className: styles.badge, "data-testid": "greeting-badge" }, { children: [_jsxs("h2", Object.assign({ className: styles.badge__title }, { children: ["Hello, ", name, " \uD83D\uDC4B"] })), _jsxs("h4", Object.assign({ className: styles.badge__subtitle }, { children: [subtitle, "."] }))] })));
};
export default GreetingBadge;
